import API, { graphqlOperation } from "@aws-amplify/api";
import * as mutations from "../../graphql/mutations";
import * as queries from "../../graphql/queries";
import { makeGraphQLRequest } from "..";
const createEntity = async (object) => {
  try {
    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.createEntityAI, { input: object })
    );
    return response.data.createEntityAI;
  } catch (error) {
    console.error("Error creating EntityAI:", error);
    throw error;
  }
};

const updateEntity = async (id, args) => {
  try {
    // First, fetch the current version of the EntityAI
    const getEntityAIResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getEntityAI, { id })
    );
    const currentEntityAI = getEntityAIResponse.data.getEntityAI;

    // Prepare the update input
    const updateInput = { id, _version: currentEntityAI._version };
    args.forEach((arg) => {
      updateInput[arg.property] = arg.value;
    });

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.updateEntityAI, { input: updateInput })
    );
    return response.data.updateEntityAI;
  } catch (error) {
    console.error("Error updating EntityAI:", error);
    throw error;
  }
};

const deleteEntity = async (id) => {
  try {
    // First, fetch the current version of the EntityAI
    const getEntityAIResponse = await makeGraphQLRequest(
      graphqlOperation(queries.getEntityAI, { id })
    );
    const currentEntityAI = getEntityAIResponse.data.getEntityAI;

    const response = await makeGraphQLRequest(
      graphqlOperation(mutations.deleteEntityAI, {
        input: { id, _version: currentEntityAI._version },
      })
    );
    return response.data.deleteEntityAI;
  } catch (error) {
    console.error("Error deleting EntityAI:", error);
    throw error;
  }
};

const getEntitiesByWorkspaceID = (workspaceID) =>
  makeGraphQLRequest(
    graphqlOperation(queries.entitiesByWorkspace, { workspaceID: workspaceID })
  );

export default {
  createEntity,
  updateEntity,
  deleteEntity,
  getEntitiesByWorkspaceID,
};
